// extracted by mini-css-extract-plugin
export default {"logoColor1":"logo_logoColor1__K8rRU theme-logo__color1","logoColor2":"logo_logoColor2__hpQMU theme-logo__color2","rotate180":"logo_rotate180__vwxCv"};